import { render } from "./YoutubeVideos.vue?vue&type=template&id=60f4d9e7&scoped=true"
import script from "./YoutubeVideos.vue?vue&type=script&lang=js"
export * from "./YoutubeVideos.vue?vue&type=script&lang=js"

import "./YoutubeVideos.vue?vue&type=style&index=0&id=60f4d9e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f4d9e7"]])

export default __exports__